import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import LandingShell from './LandingShell';
import { Button } from './ui/button';
import { LEGAL_STATUS_DATE } from '../legal/versions';
import '../pages/Legal.css';

/**
 * Shared frame for the legal pages (imprint, privacy, terms, AUP, DPA): the
 * landing shell with its login CTA, the two-tone h1 and the status line.
 * Also scrolls to the URL hash, which BrowserRouter does not do on cross-page
 * navigation (e.g. the footer's /privacy#cookies link).
 */
const LegalShell = ({ title, accent, children }) => {
  const navigate = useNavigate();
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: 'smooth' });
  }, [hash]);

  return (
    <LandingShell navRight={<Button size="sm" onClick={() => navigate('/login')}>Log in</Button>}>
      <article className="legal-main">
        <h1 className="legal-h1">
          {title} <span className="legal-h1__accent">{accent}</span>
        </h1>
        <p className="legal-meta">Status: {LEGAL_STATUS_DATE}</p>
        {children}
      </article>
    </LandingShell>
  );
};

export default LegalShell;
